<h1 mat-dialog-title class="!text-xl !font-medium">{{ data.title }}</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions class="flex flex-col-reverse gap-4 md:flex-row">
  <button mat-button class="!basic w-full md:w-auto" (click)="onNoClick()">
    <mat-icon>close</mat-icon>
    Cancelar
  </button>
  <button mat-flat-button class="primary w-full md:w-auto" (click)="onConfirmClick()">
    <mat-icon>check</mat-icon>
    Confirmar
  </button>
</div>
